export const account = {

    // --- My account (new settings screen: menu.vue + AccountWelcome.vue) ---
    mc_title: `Minha conta`,
    mc_subtitle: `Configurações da sua conta e do seu negócio`,
    mc_group_account: `Conta`,
    mc_home: `Início`,
    mc_mydata: `Meus dados`,
    mc_subscription: `Assinatura`,
    mc_billing: `Faturamento eletrônico`,
    mc_whatsapp: `WhatsApp Business`,
    mc_notifications: `Notificações`,
    mc_team: `Gestão de equipe`,
    mc_team_badge: `Novo`,
    mc_integrations: `Integrações`,
    mc_hello: `Olá`,
    mc_welcome_sub: `Bem-vindo à sua conta. Aqui você gerencia os dados do seu negócio e as configurações que o sistema usa para trabalhar por você.`,
    mc_quick: `Acesso rápido`,
    mc_card_account_title: `Configurações da conta`,
    mc_card_account_desc: `Dados de contato, idioma do painel e segurança.`,
    mc_card_subscription_desc: `Seu plano e o faturamento da assinatura.`,
    mc_card_billing_desc: `Emissores fiscais e qual emissor fatura cada propriedade.`,
    mc_card_whatsapp_desc: `A conexão que o sistema usa para falar com seus hóspedes.`,
    mc_card_notifications_desc: `Quais alertas você recebe e por quais canais.`,
    mc_card_team_desc: `Convide colaboradores e gerencie as permissões deles.`,
    mc_card_integrations_desc: `Conexões com serviços externos.`,

  p1: `Gerencie sua conta`,
  p2: `Configurações da conta`,
  p3: `Idioma`,
  p4: `Login e segurança`,
  p5: `Minha assinatura`,
  p6: `Informações de faturamento`,
  p7: `WhatsApp Business`,
  p8: `Integrações`,
  p9: `Configurações da conta`,
  p10: `Gerencie as informações de contato onde você receberá todas as comunicações da WACheckin.`,
  p11: `Dados atualizados com sucesso`,
  p12: `Idioma da plataforma`,
  p13: `Selecione o idioma de sua preferência para o painel de controle. Esta configuração não afeta o idioma do check-in que seus hóspedes recebem, pois isso depende das configurações do dispositivo deles.`,
  p14: `Selecione o idioma na lista`,
  p15: `Selecionar idioma`,
  p16: `Espanhol`,
  p17: `Inglês`,
  p18: `Atualizar idioma`,
  p19: `Idioma aplicado com sucesso`,
  p20: `Aqui você pode atualizar sua senha para manter sua conta segura.`,
  p21: `Deseja alterar sua senha?`,
  p22: `Alterar senha`,
  p23: `Verifique seu e-mail`,
  p24: `Para continuar com a alteração da senha, verifique sua caixa de entrada e siga os passos`,
  p25: `Continuar`,
  p26: `Ops! Ocorreu um erro inesperado`,
  p27: `Dados atualizados com sucesso`,
  p28: `WhatsApp for Business`,
  p29: `Conecte sua conta do WhatsApp Business à nossa plataforma e envie mensagens diretamente aos seus hóspedes a partir do seu número personalizado.`,
  p30: `Nenhuma conta conectada.`,
  p31: `Conectar conta`,
  p32: `Conta`,
  p33: `Conectada`,
  p34: `Desconectar conta`,
  p35: `Carregando informações...`,
  p36: `Desconectar o WhatsApp for Business`,
  p37: `Está pensando em desconectar o WhatsApp for Business e parar de enviar mensagens aos seus hóspedes pelo WhatsApp?`,
  p38: `Desconectar`,
  p39: `Conta do WhatsApp Business desconectada com sucesso`,
  p40: `Não foi possível desconectar a conta do WhatsApp Business, entre em contato com o suporte`,
  p41: `Número de telefone`,
  p42: `Conta do Facebook`,
  p43: `Dados do negócio`,
  p44: `Você precisa ter um número de telefone válido e exclusivo para usá-lo com a API do WhatsApp Business.`,
  p45: `Você receberá um código de verificação para autenticar seu número na nossa plataforma.`,
  p46: `Seu número de telefone comercial deve ser um número válido que atenda aos critérios da`,
  p47: `plataforma WhatsApp for Business.`,
  p48: `Você receberá um código de verificação para autenticar seu número na nossa plataforma.`,
  p49: `Voltar ao status da conta`,
  p50: `Continuar`,
  p51: `Você precisa ter uma conta pessoal do Facebook (vinculada ao seu e-mail comercial)`,
  p52: `Se você criou e conectou uma conta do Facebook Business a este sistema, precisa autenticá-la antes de iniciar o processo de onboarding clicando em Entrar com o Facebook.`,
  p53: `Para autenticar sua conta comercial, abra`,
  p54: `este link`,
  p55: `em uma aba separada.`,
  p56: `Você precisa gerar um código no seu aplicativo de autenticação e inseri-lo no campo "Inserir código".`,
  p57: `Depois de confirmado, você pode fechar esta aba.`,
  p58: `Voltar ao status da conta`,
  p59: `Voltar`,
  p60: `Continuar`,
  p61: `Prepare os dados do seu negócio`,
  p62: `Você precisa ter em mãos as informações do seu negócio: a razão social e o endereço da sua empresa, além da conta comercial da forma como deseja que seja exibida.`,
  p63: `Você precisa ter um site comercial válido.`,
  p64: `Você precisa verificar sua conta com a Meta o quanto antes. Um negócio verificado pode começar enviando 1000 mensagens por dia. Se você não verificar sua conta, a Meta a desativará.`,
  p65: `De acordo com a política da Meta, uma conta comercial não verificada só pode ser vinculada a dois números. Verifique a conta para vinculá-la a mais números.`,
  p66: `Voltar ao status da conta`,
  p67: `Voltar`,
  p68: `Continuar`,
  p69: `Conta do WhatsApp Business conectada com sucesso`,

  p70: `Faturamento`,
  p71: `Status`,
  p72: `Valor cobrado`,
  p73: `Pago`,
  p74: `Pendente`,
  p75: `Ver fatura`,
  p76: `Nenhum registro de faturamento encontrado`,
  p77:`Data`,
  p78: ``,
  p79: ``,
  p80: ``,
};
